const PERMISSION_KEY= "crm:campaign_zone";
const PAGE_URL = {
    CAMPAIGN_ZONE_PAGE: "/admin/crm/campaign-zone"
}

export {PERMISSION_KEY, PAGE_URL}

